import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const api = {
  // Services
  getServices: () => axios.get(`${API}/services`).then(r => r.data),
  getService: (slug) => axios.get(`${API}/services/${slug}`).then(r => r.data),

  // Blog
  getBlogPosts: (category) => {
    const params = category && category !== "All" ? `?category=${category}` : "";
    return axios.get(`${API}/blog${params}`).then(r => r.data);
  },
  getBlogPost: (slug) => axios.get(`${API}/blog/${slug}`).then(r => r.data),

  // Team & Testimonials
  getTeam: () => axios.get(`${API}/team`).then(r => r.data),
  getTestimonials: () => axios.get(`${API}/testimonials`).then(r => r.data),

  // Contact & Newsletter
  submitContact: (data) => axios.post(`${API}/contact`, data).then(r => r.data),
  subscribeNewsletter: (email) => axios.post(`${API}/newsletter`, { email }).then(r => r.data),

  // Admin - Blog CRUD
  verifyAdmin: (password) => axios.post(`${API}/admin/verify?password=${encodeURIComponent(password)}`).then(r => r.data),
  createBlogPost: (data, password) => axios.post(`${API}/admin/blog?password=${encodeURIComponent(password)}`, data).then(r => r.data),
  updateBlogPost: (slug, data, password) => axios.put(`${API}/admin/blog/${slug}?password=${encodeURIComponent(password)}`, data).then(r => r.data),
  deleteBlogPost: (slug, password) => axios.delete(`${API}/admin/blog/${slug}?password=${encodeURIComponent(password)}`).then(r => r.data),
};
